<div class="error-page" [ngStyle]="errorStyles">
  <div class="error-page__wrapper">
    <h2>
      <ng-content select="app-error-page-title"></ng-content>
    </h2>
    <p class="error-page__message">
      <ng-content select="app-error-page-message"></ng-content>
    </p>
    <ng-content></ng-content>
  </div>
</div>
